import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '@babel/polyfill';
import { setWebpackPublicFromBackend } from '../utility/customize-webpack';
import { attemptRegisterForDevs } from '../dev/dev-barrier/register';
import { LogoutProgress } from '../components/LogoutProgress';

let LogoutProgressRoot: any = LogoutProgress;

const redirectToLogout = () => {
  redirectToLogoutProgress();
};

const redirectToLogoutProgress = () => {
  window.location.replace('/logout/progress');
};

const redirectToLogoutSuccess = () => {
  window.location.replace('/logout/success');
};

if (process.env.NODE_ENV === 'development') {
  // Enable hot module reload for dev builds
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { hot } = require('react-hot-loader');
  LogoutProgressRoot = hot(module)(LogoutProgress);
}

const anchorDiv = document.querySelector('#logout');

if (anchorDiv) {
  setWebpackPublicFromBackend();

  attemptRegisterForDevs();

  ReactDOM.render(
    <LogoutProgressRoot 
      onUserSessionOk={redirectToLogout}
      onNoUserSessionFound={redirectToLogoutProgress}
      onUserSessionFailed={redirectToLogoutProgress}
      onAllLogoutsComplete={redirectToLogoutSuccess}
    />,
    anchorDiv
  );

  const html = document.querySelector('html');
  if (html) {
    html.setAttribute('lang', 'en');
  }
}